"use client";

import { createContext, PropsWithChildren, useContext, useState } from "react";
import { ThemesValues } from "./constants";
import { setTheme } from "./themeActions";
import { DarkModeToggle } from "@xenithlabs/xenith-ui";

type ThemeContextType = {
  theme: ThemesValues;
  setTheme: (theme: ThemesValues) => void;
};
const ThemeContext = createContext<ThemeContextType>({
  theme: "system",
} as ThemeContextType);

const ThemeProvider = ({
  children,
  theme,
}: PropsWithChildren<{ theme: ThemesValues }>) => {
  const [themeState, setThemeState] = useState<ThemesValues>(theme);
  const _setTheme = async (theme: ThemesValues) => {
    setThemeState(theme);
    document.querySelector("html")?.setAttribute("data-theme", theme);
    await setTheme(theme);
  };

  return (
    <ThemeContext.Provider
      value={{
        theme: themeState,
        setTheme: _setTheme,
      }}
    >
      {children}
    </ThemeContext.Provider>
  );
};

const ThemeToggle = () => {
  const { theme, setTheme } = useTheme();

  return (
    <DarkModeToggle
      defaultValue={theme}
      onValueChange={(v) => setTheme(v as ThemesValues)}
    />
  );
};

const useTheme = () => {
  const context = useContext(ThemeContext);
  return {
    ...context,
  };
};

export { ThemeProvider, useTheme, ThemeToggle };
